import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserSubscriptions } from "../../redux/actions/userSubscriptionAction";
import UserSubscriptionTable from "./UserSubscriptionTable";

const UserSubscriptions = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("");

    const allUserSubscriptions = useSelector((state) => state.userSubscription.allUserSubscriptions);

    const fetchData = useCallback(() => {
        dispatch(getUserSubscriptions(setLoading));
    }, [dispatch]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const filteredSubscriptions = useMemo(() => {
        let rows = allUserSubscriptions || [];
        const query = search.trim().toLowerCase();

        if (query) {
            rows = rows.filter((item) => {
                const name = [item.firstName, item.lastName].filter(Boolean).join(" ").toLowerCase();
                const matchesVehicle = Array.isArray(item.vehicles)
                    ? item.vehicles.some((vehicle) =>
                          String(vehicle?.vehicleNumber || "").toLowerCase().includes(query)
                      )
                    : false;
                return (
                    name.includes(query) ||
                    String(item.mobile || "").toLowerCase().includes(query) ||
                    String(item.deviceType || "").toLowerCase().includes(query) ||
                    matchesVehicle
                );
            });
        }

        if (statusFilter) {
            rows = rows.filter((item) => item.subscriptionStatus === statusFilter);
        }

        return rows;
    }, [allUserSubscriptions, search, statusFilter]);

    return (
        <UserSubscriptionTable
            heading="User Subscriptions"
            data={filteredSubscriptions}
            loading={loading}
            search={search}
            setSearch={setSearch}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            refreshData={fetchData}
        />
    );
};

export default UserSubscriptions;